import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import NotificationItem from './NotificationItem/';
import './NotificationList.css';
import { routes } from '../../shared/helpers';

const NotificationList = ({
  notifications,
  popup,
  screen,
  onClick,
  onNotificationClick,
}) => (
  <div className={`col-12 notification-list__${popup ? 'popup' : 'screen'}`}>
    <div className="row">
      <div className="col-12">
        <div className="row">
          <div className="col-12">
            <div className="row notification-header pt-2 pb-3">
              <div className="col">
                <h3 className="t-14 text-darkgreen">Notifications</h3>
              </div>
            </div>
            <div className="row notification-body">
              <div
                className={`col-12 ${notifications.length === 0 && 'd-flex'}`}
              >
                {notifications.map(notification => (
                  <NotificationItem
                    key={notification.id}
                    notification={notification}
                    screen={screen}
                    onNotificationClick={onNotificationClick}
                  />
                ))}
                {notifications.length === 0 && (
                  <div className="row align-self-center flex-fill">
                    <div className="col text-left text-lg-center">
                      <p>You have no notifications</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {popup && (
            <div className="col-12">
              {notifications.length > 10 && (
                <div className="col-12">
                  <div className="row notification-footer pt-2 text-center">
                    <div className="col">
                      <Link
                        to={routes.notifications}
                        className="t-14 text-blue"
                        onClick={onClick}
                      >
                        See All
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

NotificationList.propTypes = {
  notifications: PropTypes.array,
  onClick: PropTypes.func,
  screen: PropTypes.bool,
  popup: PropTypes.bool,
  onNotificationClick: PropTypes.func,
};

export default NotificationList;



// WEBPACK FOOTER //
// ./src/components/NotificationList/NotificationList.js